import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {city_fields_replacer} from "../../redux/actions";

export const CityReplacer = () => {
    const dispatch = useDispatch()
    const valueFrom = useSelector(state => state.app.fields.cityFrom.value)
    const valueTo = useSelector(state => state.app.fields.cityTo.value)
    return (
        <React.Fragment>
            <img src="https://scs-aero.ru/wp-content/themes/scs2022/images/icon-city-replace.svg"
                 alt=""
                 title=""
                 onClick={()=>dispatch(city_fields_replacer(valueFrom,valueTo))}
            />
        </React.Fragment>
    )
}